import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  getPictreePhotoShootByAssetCommon,
  getPictreePhotoShootTrendByAssetCommon,
  getPictreeCheckInByAssetCommon,
  getPictreeCheckInTrendByAssetCommon,
  setCurrentPage,
  setPictreeChartSize,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import CalendarRangePicTreeCommon from "components/Calendar/CalendarRangePicTreeCommon";
import PhotoShootAssetTypeCommon from "components/PicTree/Home/PhotoShootAssetTypeCommon";
import CheckInAssetTypeCommon from "components/PicTree/Home/CheckInAssetTypeCommon";
import PicTreeTablePhotoSubTypeCommon from "components/Table/PicTreeTablePhotoSubTypeCommon";
import PicTreeTableCheckInAssetTypeCommon from "components/Table/PicTreeTableCheckInAssetTypeCommon";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";
import SingleSelect from "components/Select/SingleSelect";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  gridSection: { marginTop: theme.spacing(1) },
  loaderBox: { width: "100%", minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
  loaderBarImg: { width: 40 },
  noData: { minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
}));

const PicTreeReviewByAssetTypeCommon = ({
  pageTopLoader,
  dateRangePicTreeCommon,
  selectedSeason,
  dataType,
  photoShootTrendByAsset,
  checkInByAssetData,
  setCurrentPage,
  getPictreePhotoShootByAssetCommon,
  getPictreePhotoShootTrendByAssetCommon,
  getPictreeCheckInByAssetCommon,
  getPictreeCheckInTrendByAssetCommon,
  setPictreeChartSize,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: "日別", value: "day" });
  const lastAutoFetchKeyRef = useRef("");

  useEffect(() => { setCurrentPage(window.location.pathname); }, [setCurrentPage]);
  useEffect(() => {
    const hasSeason = Array.isArray(selectedSeason) && selectedSeason.length > 0;
    const hasDateRange = dateRangePicTreeCommon[0] && dateRangePicTreeCommon[1];
    if (!hasSeason || !hasDateRange) return;

    const seasonKey = selectedSeason.map((season) => season.seasonId).join(",");
    const autoFetchKey = `${dataType}:${seasonKey}`;
    if (lastAutoFetchKeyRef.current === autoFetchKey) return;
    lastAutoFetchKeyRef.current = autoFetchKey;

    if (dataType === "report") {
      getPictreePhotoShootByAssetCommon();
      getPictreePhotoShootTrendByAssetCommon("day");
    } else {
      getPictreeCheckInByAssetCommon();
      getPictreeCheckInTrendByAssetCommon("day");
    }
  }, [
    dataType,
    selectedSeason,
    dateRangePicTreeCommon,
    getPictreePhotoShootByAssetCommon,
    getPictreePhotoShootTrendByAssetCommon,
    getPictreeCheckInByAssetCommon,
    getPictreeCheckInTrendByAssetCommon,
  ]);

  const handleChange = (event) => {
    const value = event.target.value;
    setChartSize({ name: value === "hour" ? "時間別" : "日別", value });
    setPictreeChartSize(value);
    if (dataType === "report") {
      getPictreePhotoShootTrendByAssetCommon(value);
    } else if (value === "day") {
      getPictreeCheckInTrendByAssetCommon("day");
    }
  };
  const checkInTrend = checkInByAssetData?.trend || [];
  const activeTrend = dataType === "report" ? photoShootTrendByAsset : checkInTrend;
  const legend = activeTrend?.[0]
    ? Object.keys(activeTrend[0]).filter((key) => key !== "date")
    : [];
  const seriesConfig = legend.reduce((config, key) => ({ ...config, [key]: key }), {});

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container spacing={0} direction="row" style={{ marginTop: -16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item><Breadcrumbs separator="›" className={classes.breadcrumbs}>
          <Typography>PicTrée 汎用事業者</Typography>
          <Typography>アセットタイプ別</Typography></Breadcrumbs></Grid>
          <Grid item><CalendarRangePicTreeCommon mDate="2026/09/01" page="pictree" pictree /></Grid>
        </Grid>
        <Grid container spacing={0}><Grid item xs={12}><Card><CardContent>{dataType === "report" ? <PhotoShootAssetTypeCommon /> : <CheckInAssetTypeCommon />}</CardContent></Card></Grid></Grid>
        <Grid container spacing={0} style={{ marginTop: 16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item><SingleSelect selected={chartSize} options={dataType === "report" ? [{ name: "時間別", value: "hour" }, { name: "日別", value: "day" }] : [{ name: "日別", value: "day" }]} handleChange={handleChange} /></Grid>
        </Grid>
        <Grid container spacing={1} className={classes.gridSection}><Grid item xs={12}>
          {pageTopLoader ? <div className={classes.loaderBox}><img alt="" className={classes.loaderBarImg} src="/static/images/loader-bar.gif" /></div> : checkInByAssetData?.status === "error" ? <div className={classes.noData}><Chip label="データの取得に失敗しました" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} /></div> : activeTrend.length > 0 ? (
            <LineChartPictreePhotoShoot legend={legend} xAisData={activeTrend[0].date} seriesData={activeTrend} chartType="bar" chartConfig={seriesConfig} colorValue={V.genericColorPallette} yAxis={[{ type: "value", name: dataType === "report" ? "レビューOK基数" : "チェックイン数", axisLine: { show: true } }]} />
          ) : <div className={classes.noData}><Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} /></div>}
        </Grid></Grid>
        <Grid container spacing={1} className={classes.gridSection}><Grid item xs={12}>{dataType === "report" ? <PicTreeTablePhotoSubTypeCommon photoShootTrend={photoShootTrendByAsset} /> : <PicTreeTableCheckInAssetTypeCommon trend={checkInTrend} />}</Grid></Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
  selectedSeason: state.pictreeCommon.selectedSeason,
  dataType: state.pictreeCommon.dataType,
  photoShootTrendByAsset: state.pictreeCommon.photoShootTrendByAsset,
  checkInByAssetData: state.pictreeCommon.checkInByAssetData,
});
const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPictreePhotoShootByAssetCommon: (param) => dispatch(getPictreePhotoShootByAssetCommon(param)),
  getPictreePhotoShootTrendByAssetCommon: (param) => dispatch(getPictreePhotoShootTrendByAssetCommon(param)),
  getPictreeCheckInByAssetCommon: (param) => dispatch(getPictreeCheckInByAssetCommon(param)),
  getPictreeCheckInTrendByAssetCommon: (param) => dispatch(getPictreeCheckInTrendByAssetCommon(param)),
  setPictreeChartSize: (param) => dispatch(setPictreeChartSize(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeReviewByAssetTypeCommon);
